import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import HomePage from '@/pages/home'
import AboutPage from '@/pages/about'
import JoinPage from '@/pages/join'
import VuePdf from '../../src/components/vue-pdf'

export default new Router({
    routes: [
        { path: '/', component: HomePage, name: 'home' },
        { path: '/about', component: AboutPage, name: 'about' },
        { path: '/join', component: JoinPage, name: 'join' },
        { path: '/pdf', component: VuePdf, name: 'vue-pdf' }
    ]
})